import React from "react";
import { Sparkles, Trophy, Flame, Sprout } from "lucide-react";

const ICONS = {
  nouveau: Sprout,
  demarrage: Sparkles,
  "en-route": Flame,
  pro: Trophy,
};

export default function BadgeCard({ badge }) {
  if (!badge) return null;
  const Icon = ICONS[badge.current?.key] || Sparkles;
  const pctToNext = badge.next
    ? Math.round(((badge.score - (badge.current?.threshold || 0)) /
        (badge.next.threshold - (badge.current?.threshold || 0))) * 100)
    : 100;
  return (
    <div
      className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 flex items-center gap-5"
      data-testid="badge-card"
    >
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center text-white shrink-0"
        style={{ backgroundColor: badge.current?.color || "#6366F1" }}
      >
        <Icon size={26} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Niveau actuel</p>
        <p className="font-display text-2xl font-bold text-slate-900" data-testid="badge-current">
          {badge.current?.label || "—"}
        </p>
        <p className="text-xs text-slate-500 mt-0.5">
          Score {badge.score} · {badge.demarches_pct}% démarches · {badge.referrals} parrain{badge.referrals > 1 ? "s" : ""}
        </p>
        {badge.next ? (
          <div className="mt-2.5">
            <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full bg-indigo-500 transition-all" style={{ width: `${pctToNext}%` }} />
            </div>
            <p className="text-xs text-slate-400 mt-1.5">
              Plus que <strong>{badge.to_next}</strong> point(s) pour <strong>{badge.next.label}</strong>
            </p>
          </div>
        ) : (
          <p className="text-xs text-emerald-600 mt-2 font-medium">🏆 Niveau max atteint</p>
        )}
      </div>
    </div>
  );
}
